var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ServicesDisplayCards',{attrs:{"services":_vm.services,"placeholder":"jss-products"}})
}
var staticRenderFns = []

export { render, staticRenderFns }